import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import { profileTabListData , profileTabPannelName} from '../../Configuration/ConfigurationMenu';
import { useDispatch, useSelector } from 'react-redux';
import { handleValidateCodevalue } from '../../Utility/constant';
import { handleCreateEditConfiguration } from '../../Store/Global/action';
import CreateEditUser from '../Configuration/User/CreateEditUser';
import McpSettings from './McpSettings';
import './profile.css';
const ProfileHomePage = ({}) => {
    const [selectedTab, setSelectedTab] = React.useState("basicInformation");
   
    const handleChange = (event, newValue) => {
        setSelectedTab(newValue);
    };
    const currentUser = useSelector(state => state?.owner?.currentuser);
    const dispatch = useDispatch()
    const internationalise = useSelector(state => state?.internationalise?.currentHashMapData);
    useEffect(()=>{
    return ()=>{
        dispatch( handleCreateEditConfiguration(false))
    }
    },[])
    const isCreateEdit = useSelector(state => state?.global?.isCreateEdit);
    const [isViewMode , setIsViewMode] = useState()
    return (
        <React.Fragment>
            <Box className="profile-page">
                <TabContext value={selectedTab}>
                    {!isCreateEdit && 
                    <Box className="profile-tabs">
                        <TabList onChange={handleChange} variant ="standard" aria-label="configuration Menu" allowScrollButtonsMobile>
                            {
                                profileTabListData.map((item, index) => {
                                    const translated = handleValidateCodevalue(internationalise, item?.label);
                                    const label = (translated && translated !== item?.label) ? translated : (item?.defaultLabel || item?.label);
                                    return <Tab key={item.value || index} label={label} value= {item?.value} />
                                })
                            }
                        </TabList>
                    </Box>}
                    
                    <TabPanel value={profileTabPannelName?.basicInformation}>
                        {<CreateEditUser
                            height = {'calc(100vh - 170px)'}
                            isUserScreen = {false}
                            setIsViewMode = {setIsViewMode}
                            isViewMode = {true}
                            isEdituser = {true} 
                            currentuserid={currentUser?.userId}
                        />}
                    </TabPanel>
                    
                    <TabPanel value={profileTabPannelName?.mcpSettings}>
                        <McpSettings currentUser={currentUser} />
                    </TabPanel>
                </TabContext>
            </Box>
        </React.Fragment>
    )
}

export default ProfileHomePage;